import { Duration } from 'luxon';

export function formatTimeClean(timeInSeconds: number): string {
  // Guard against non-finite input; Luxon's shiftTo() throws on Infinity/NaN.
  const safeSeconds = Number.isFinite(timeInSeconds) ? timeInSeconds : 0;
  const duration = Duration.fromMillis(safeSeconds * 1000).shiftTo(
    'hours',
    'minutes',
    'seconds'
  );

  const hours = duration.hours ? String(duration.hours).padStart(2, '0') : '00';
  const minutes = duration.minutes
    ? String(duration.minutes).padStart(2, '0')
    : '00';
  const seconds = duration.seconds
    ? String(Math.floor(duration.seconds)).padStart(2, '0')
    : '00';

  // Return only the relevant time parts
  if (hours !== '00') return `${hours}:${minutes}:${seconds}`;
  if (minutes !== '00') return `${minutes}:${seconds}`;
  return `${seconds}`;
}
